export enum AUDIO_NOTE_REMOVAL_MODAL_MODE {
    discard = 'discard',
    redo = 'redo',
}
